import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-photocopying',
  templateUrl: './photocopying.component.html',
  styleUrls: ['./photocopying.component.scss']
})
export class PhotocopyingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
